(function () {
  function getRedirectUrl(form) {
    const card = form.closest('.dashcam-consultation__form-card');
    return (card && card.getAttribute('data-redirect-url')) || '';
  }

  function initConsultationForm(form) {
    const bodyField = form.querySelector('[data-consultation-body-field]');
    const submitButton = form.querySelector('[type="submit"]');

    // After successful POST, Shopify renders the success state on the same page.
    // Detect that state and redirect the visitor.
    const successEl = form.querySelector('.dashcam-consultation__status--success');
    const redirectUrl = getRedirectUrl(form);
    if (successEl && redirectUrl) {
      // Small delay so the success UI can be seen briefly (and to avoid abrupt jump).
      setTimeout(function () {
        window.location.href = redirectUrl;
      }, 800);
    }

    form.addEventListener('submit', function () {
      const name = form.querySelector('[data-consultation-name]');
      const phone = form.querySelector('[data-consultation-phone]');
      const dashcamType = form.querySelector('[data-consultation-dashcam-type]');

      if (bodyField) {
        bodyField.value = [
          '--- Free Dashcam Consultation ---',
          '',
          'Full Name: ' + (name ? name.value.trim() : ''),
          'Mobile Number: ' + (phone ? phone.value.trim() : ''),
          'Dashcam Type: ' + (dashcamType && dashcamType.value ? dashcamType.value : 'Not specified')
        ].join('\n');
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }
    });
  }

  function initAll() {
    document.querySelectorAll('form[id^="FreeConsultationForm-"]').forEach(function (form) {
      initConsultationForm(form);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    event.target.querySelectorAll('form[id^="FreeConsultationForm-"]').forEach(function (form) {
      initConsultationForm(form);
    });
  });
})();
